const scrollRestoration = {
  disable() {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  },
};

export default scrollRestoration;
